module.exports = __webpack_public_path__ + "img/login_bg0.255d420f.jpg";